import { css } from 'lit';

export const styles = css`
  .card {
    margin: 20px;
    padding: 10px 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }
`;

